import { CalendarProps, Calendar as Schedule } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './style.css'

type ScheduleProps = CalendarProps

const CALENDAR_WRAPPER_CLASS = 'calendar-schedule-wrapper'

export const Calendar = (props: ScheduleProps) => {
  return (
    <div className={CALENDAR_WRAPPER_CLASS}>
      {/* @ts-expect-error react-big-calendar Calendar type is incompatible with JSX */}
      <Schedule {...props} />
    </div>
  )
}
